export default {
    'isNotEmpty': function (value) {
        return !_.isEmpty(value);
    },
    'isNotNull': function (value) {
        return !_.isNull(value);
    }
}


// WEBPACK FOOTER //
// ./src/helpers/lodashMethods.js